export default "__VITE_ASSET__Gc1dbrS5__"